<template>
  <div>
    <!-- 各学校教育平台资源使用情况 -->
    <Echart :options="options" height="380px" width="100%"></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart';
import echarts from 'echarts';

export default {
  data() {
    return {
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    cdata: {
      handler(newData) {
        this.options = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '2%',
            right: '4%',
            bottom: '5%',
            top: '16%',
            containLabel: true
          },
          legend: {
            data: ['评量工具', 'IEP', '教案'],
            // right: 10,
            top: 12,
            textStyle: {
              color: '#fff'
            },
            // itemWidth: 12,
            // itemHeight: 10
            itemGap: 35
          },
          xAxis: {
            type: 'category',
            data: newData.xAxisData,
            axisLine: {
              lineStyle: {
                color: 'white'
              }
            }
          },

          yAxis: {
            type: 'value',
            max: '150',
            axisLine: {
              show: false,
              lineStyle: {
                color: 'white'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            },
            axisLabel: {}
          },

          series: [
            {
              name: '评量工具',
              type: 'bar',
              barWidth: '15%',
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: '#fccb05'
                    },
                    {
                      offset: 1,
                      color: '#f5804d'
                    }
                  ]),
                  barBorderRadius: 12
                }
              },
              data: newData.yAxisData[0]
            },
            {
              name: 'IEP',
              type: 'bar',
              barWidth: '15%',
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: '#8bd46e'
                    },
                    {
                      offset: 1,
                      color: '#09bcb7'
                    }
                  ]),
                  barBorderRadius: 11
                }
              },
              data: newData.yAxisData[1]
            },

            {
              name: '教案',
              type: 'bar',
              barWidth: '15%',
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: '#ffb069' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#ec2e85' // 100% 处的颜色
                    }
                  ]),
                  barBorderRadius: 11
                }
              },
              data: newData.yAxisData[2]
            }
          ]
        };
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
